class WotlinkTestimonialsCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.wotlink-home-testimonials__track');
    this.pages = Array.from(this.querySelectorAll('[data-page]'));
    this.dots = Array.from(this.querySelectorAll('[data-dot]'));
    this.intervalMs = Number.parseInt(this.dataset.autoplayInterval, 10) || 6000;
    this.currentIndex = 0;
    this.timer = null;
    this.isPaused = false;
    this.pageCount = this.pages.length;

    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.onFocusIn = this.onFocusIn.bind(this);
    this.onFocusOut = this.onFocusOut.bind(this);
    this.onResize = this.onResize.bind(this);

    if (this.pageCount <= 1) {
      this.applyTransform(false);
      return;
    }

    window.addEventListener('resize', this.onResize);

    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        this.goTo(index);
        this.restartAutoplay();
      });
    });

    this.addEventListener('mouseenter', this.onMouseEnter);
    this.addEventListener('mouseleave', this.onMouseLeave);
    this.addEventListener('focusin', this.onFocusIn);
    this.addEventListener('focusout', this.onFocusOut);

    this.goTo(0, false);
    this.startAutoplay();
  }

  disconnectedCallback() {
    this.stopAutoplay();
    window.removeEventListener('resize', this.onResize);
    this.removeEventListener('mouseenter', this.onMouseEnter);
    this.removeEventListener('mouseleave', this.onMouseLeave);
    this.removeEventListener('focusin', this.onFocusIn);
    this.removeEventListener('focusout', this.onFocusOut);
  }

  onResize() {
    this.applyTransform(false);
  }

  applyTransform(animate) {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!animate || reduceMotion) {
      this.track.style.transition = 'none';
    } else {
      this.track.style.transition = '';
    }

    this.track.style.transform = `translate3d(-${this.currentIndex * 100}%, 0, 0)`;

    if (!animate || reduceMotion) {
      void this.track.offsetWidth;
      this.track.style.transition = reduceMotion ? 'none' : '';
    }
  }

  goTo(index, animate = true) {
    if (!this.pageCount) return;

    this.currentIndex = ((index % this.pageCount) + this.pageCount) % this.pageCount;

    this.pages.forEach((page, pageIndex) => {
      page.setAttribute('aria-hidden', pageIndex === this.currentIndex ? 'false' : 'true');
    });

    this.dots.forEach((dot, dotIndex) => {
      const isActive = dotIndex === this.currentIndex;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-current', isActive ? 'true' : 'false');
    });

    this.applyTransform(animate);
  }

  next() {
    if (this.pageCount <= 1) return;
    this.goTo(this.currentIndex + 1);
  }

  onMouseEnter() {
    this.isPaused = true;
    this.stopAutoplay();
  }

  onMouseLeave() {
    this.isPaused = false;
    this.startAutoplay();
  }

  onFocusIn() {
    this.isPaused = true;
    this.stopAutoplay();
  }

  onFocusOut(event) {
    if (this.contains(event.relatedTarget)) return;
    this.isPaused = false;
    this.startAutoplay();
  }

  startAutoplay() {
    if (this.isPaused || this.pageCount <= 1 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    this.stopAutoplay();
    this.timer = window.setInterval(() => this.next(), this.intervalMs);
  }

  stopAutoplay() {
    if (this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }

  restartAutoplay() {
    this.stopAutoplay();
    this.startAutoplay();
  }
}

if (!customElements.get('wotlink-testimonials-carousel')) {
  customElements.define('wotlink-testimonials-carousel', WotlinkTestimonialsCarousel);
}
